import dayjs from 'dayjs';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { ContextColor } from '../../constants/color.enum';
import { CLOCK } from '../../controllers/util-level/clock.controller';
import { getAppLink } from '../../env';
import joinClassName from '../../utils/className.utils';
import { getContextColorStyle } from '../../utils/color.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import BodyCopyRenderer from '../BodyCopyRenderer/BodyCopyRenderer';
import ColorTagFacilitator from '../ColorTag/ColorTagFacilitator';
import ColorTagLive from '../ColorTag/ColorTagLive';
import Redirector from '../Redirector/Redirector';
import SessionOrGroupTimeDisplay from '../SessionOrGroupTimeDisplay/SessionOrGroupTimeDisplay';
import SupportGroupIcon from '../SupportGroupIcon/SupportGroupIcon';
import UsernameRenderer from '../UsernameRenderer/UsernameRenderer';
import './SupportGroupCard.scss';
var SupportGroupCard = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get group() {
            return p.supportGroup;
        },
        get color() {
            var _a, _b;
            return (_b = (_a = p.supportGroup.topic) === null || _a === void 0 ? void 0 : _a.color) !== null && _b !== void 0 ? _b : p.color;
        },
        get colorStyle() {
            return getContextColorStyle(ContextColor.Primary, s.color);
        },
        get maxParticipants() {
            return s.group.maxParticipants;
        },
        get facilitatorId() {
            return s.group.facilitatorId;
        },
        get description() {
            return s.group.description || "";
        },
        handleClick: function () {
            // console.log('clicky click');
        },
        get isTodayOrFuture() {
            return s.group.timeScheduled ? dayjs.utc(s.group.timeScheduled).local().isSameOrAfter(CLOCK.todayLocalDate, 'day') : false;
        },
        get didntStart() {
            return s.group.timeScheduled && !s.group.timeStarted && dayjs(s.group.timeScheduled).add(1, 'hour').isBefore('');
        },
        get isUpcoming() {
            return Boolean(s.isTodayOrFuture && !s.group.timeStarted && !s.didntStart && !s.group.timeEnded && !s.group.timeArchived && !s.group.timeDeleted);
        },
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName('SupportGroupCard', s.isUpcoming && 'upcoming'), "data-id": s.group.id, style: s.colorStyle, onClick: s.handleClick, "data-cy": "support-group-summary", tabIndex: 0 },
            React.createElement(Redirector, { url: getAppLink("/app/support-groups?supportGroupId=" + s.group.id), title: "Support Group App URL", shouldRedirect: p.redirectToApp },
                React.createElement("div", { className: "SupportGroupCardInner" },
                    React.createElement("header", { className: "SupportGroupCardHeader" },
                        React.createElement("div", { className: "SupportGroupCardIconWrapper" },
                            React.createElement(SupportGroupIcon, { supportGroup: p.supportGroup })),
                        React.createElement("div", { className: "SupportGroupCardHeaderInner" },
                            React.createElement("p", { className: "SupportGroupCardBeforeTitle" },
                                React.createElement("span", null,
                                    s.group.timeStarted && !s.group.timeEnded && React.createElement(React.Fragment, null,
                                        React.createElement(ColorTagLive, null),
                                        " "),
                                    "Support Group")),
                            React.createElement("h3", { className: "SupportGroupCardTitle" }, s.group.title),
                            s.group.subtitle && React.createElement("p", { className: "SupportGroupCardSubtitle" }, s.group.subtitle))),
                    React.createElement(SessionOrGroupTimeDisplay, { model: p.supportGroup }),
                    React.createElement("div", { className: "SupportGroupCardDetails" },
                        s.description && React.createElement(BodyCopyRenderer, { source: s.description, lineClamp: 2 }),
                        s.group.facilitator && React.createElement("footer", null,
                            React.createElement("div", null,
                                React.createElement("p", null,
                                    React.createElement(ColorTagFacilitator, null),
                                    " ",
                                    React.createElement(UsernameRenderer, { user: s.group.facilitator, showColorLabel: true }))))))))); } });
};
export default SupportGroupCard;
